import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { Empresa, EmpresaApi, Sucursal, SucursalInterface } from '../../../services/lbsdk';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CompaniesProvider } from '../../../providers/companies/companies.provider';
import { CompaniesPage } from '../companies';
import { AuthService } from '../../../services/auth/auth.service';
import { identifierModuleUrl } from '@angular/compiler';

/**
 * Generated class for the CompanyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-company',
  templateUrl: 'company.html',
})
export class CompanyPage {
  public empresaSeleccionada: any = null;
  company: Sucursal = null;
  action: string = "";
  empresas = []
  empresa: any;
  form: FormGroup;
  id: string;
  close: boolean = false; //ARREGLAR 
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private providerCompanies: CompaniesProvider,
    private toastCtrl: ToastController,
    private authService: AuthService,
    private empresaApi: EmpresaApi
  ) {
    
    
    this.armarForm();
    
    
    this.company = navParams.get("data")
    
    this.empresaApi.find().subscribe(respuesta => {
      this.empresas = respuesta;
      

      if(this.authService.isSuperAdministrador()){

        
          this.empresaSeleccionada = this.empresas[0]
          this.authService.empresaSeleccionada = this.empresas[0]
          
        }
        else {

          this.filtrarEmpresas();
        }
      })

    }
    
    
  

  private armarForm() {
    this.form = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      active: new FormControl('', []),
      
      
      
      // activationCode: new FormControl('', [Validators.required]),
    })
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CompanyPage');
    if (this.company.idsucursal == null) {
      console.log("Nuevo registro");
      this.action = "Nuevo registro";
      this.company.activo = false;
    } else {
      console.log("Actualizando registro => ", this.company);
      this.action = "Actualizar registro";
    }
  }
 
  guardar() {

    if (this.company.idsucursal != null) {
      this.company.fechacreacion = new Date();
      this.providerCompanies.update(this.company)
        .subscribe(() => {
          this.showToast("Registro actualizado con exito!");
          this.navCtrl.pop();
        }, error => {
          console.log(error);
        })
    } else {
      this.company.fechacreacion = new Date();
      // GUARDO EL ID DE LA EMPRESA A TRAVES DE UNA VARIABLE Y NO DEL FORMULARIO
     this.company.idempresa = this.empresaSeleccionada.idEmpresa

      this.providerCompanies.create(this.company)
        .subscribe(() => {
          this.showToast("Registro creado con exito!");
          this.navCtrl.pop();
        }, error => {
          console.log(error);
        })
    }
    console.log(this.form.value);

  }

  showToast(msg: string) {
    let position = 'bottom';
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: position
    });
    toast.present(toast);
  }


  //#region MENSAJES DE VALIDACION
  validation_messages = {
    'requiredOnly': [
      { type: 'required', message: '* Este campo es requerido.' }
    ],
    'email': [
      { type: 'required', message: '* Este campo es requerido.' },
      { type: 'email', message: '* Debe ser del formato correo.' }
    ]
  }
  //#endregion
  cambioEmpresa() {

    //SELECCIOONO LA EMPRESA 
    this.authService.empresaSeleccionada = this.empresaSeleccionada
               
  }

  
  
  filtrarEmpresas() {
    console.log("FILTRA EMPRESA ")
    let empresaUsuario = [];
    let idsMongo = this.authService.userData.sucursales.map(res => { return res.idempresa })
    console.log("MONGO ID ", idsMongo)
    this.empresas = this.empresas.filter(item => idsMongo.includes(item.idEmpresa));
    if (this.empresas.length > 0) {
      console.log("SETEA EMPRESA ---------------")
      this.empresaSeleccionada = this.empresas[0]
      this.authService.empresaSeleccionada = this.empresas[0]
    }
  }

  
}





// WEBPACK FOOTER //
// ./src/pages/companies/company/company.ts